import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export const markerVariants = cva(
  `[a]:hover:text-foreground [a]:underline [a]:underline-offset-4 group/marker relative flex min-h-4 w-full items-center gap-2 text-left text-sm text-muted-foreground [&_svg:not([class*='size-'])]:size-4`,
  {
    variants: {
      variant: {
        default: '',
        separator: 'before:mr-1 before:h-px before:min-w-0 before:flex-1 before:bg-border after:ml-1 after:h-px after:min-w-0 after:flex-1 after:bg-border',
        border: 'border-b border-border pb-2',
      },
    },
  },
)
export type MarkerVariants = VariantProps<typeof markerVariants>
